// ── ADMIN: PER-PARENT PAYMENT HISTORY ──────────────────────────────────
// esc (shared classic script) stays a bare global — not migrated yet.
// aphSetSeason/aphSetStatus/exportParentHistory wired via VIEW_INIT (phase 2
// of the onclick → addEventListener migration) instead of window; the "‹ back"
// eyebrow's route('a-parent-detail') is untouched since route() is a
// cross-cutting nav primitive still called from many not-yet-migrated views.
import { DB, currentParentId } from '../core/state.js';
import { TODAY } from '../core/format.js';
import { childName } from '../core/domain-utils.js';
import { VIEWS, VIEW_INIT } from '../core/routing.js';
import { renderChargeHistory, phSeasonRange } from './billing-shared.js';
import { exportCSV } from '../core/ui.js';

let aphSeason = 'all';
let aphStatus = '';

function aphSetSeason(v) { aphSeason = v; renderAdminHistoryTable(); }
function aphSetStatus(v) { aphStatus = v; renderAdminHistoryTable(); }

function renderAdminHistoryTable() {
  renderChargeHistory({ accountId: currentParentId, season: aphSeason, status: aphStatus, targetId: 'aphTableWrap' });
}

function exportParentHistory() {
  const { from, to } = phSeasonRange(aphSeason);
  const u = DB.users.find(x => x.id === currentParentId);
  const rows = DB.charges.filter(c =>
    c.accountId === currentParentId && c.date >= from && c.date <= to &&
    (!aphStatus || c.status === aphStatus)
  ).sort((a,b) => b.date.localeCompare(a.date))
   .map(c => [c.date, childName(c.childId), c.desc, c.type, c.amount, c.status]);
  // Was a second, independent CSV builder that quoted but did not neutralise
  // formulas. Routed through the shared exporter so there is one place where
  // that rule lives rather than two that can drift.
  exportCSV(
    `${(u ? u.firstName + '-' + u.lastName : 'parent')}-payment-history.csv`,
    ['Date','Performer','Description','Type','Amount','Status'],
    rows
  );
}

VIEWS['a-parent-history'] = () => {
  const u = DB.users.find(x => x.id === currentParentId);
  if (!u) return '<p class="empty">Account not found.</p>';
  aphSeason = 'all'; aphStatus = '';
  const seasonStartYear = (TODAY.getMonth() + 1) >= 9 ? TODAY.getFullYear() : TODAY.getFullYear() - 1;
  const html = `
    <div class="page-head">
      <span class="eyebrow check-row" onclick="route('a-parent-detail')">‹ ${esc(u.firstName)} ${esc(u.lastName)}</span>
      <h2 class="serif">Payment <em>History</em></h2>
    </div>
    <div class="card">
      <div class="card-hd">
        All charges — ${esc(u.firstName)} ${esc(u.lastName)}
        <button class="btn-ghost btn-sm" data-action="export-history">Download CSV</button>
      </div>
      <div class="filters" style="margin-bottom:16px">
        <div class="field" style="margin-bottom:0">
          <label>Season</label>
          <select id="aphSeasonSel" data-action="set-season">
            <option value="all" selected>All time</option>
            <option value="current">${seasonStartYear}–${seasonStartYear+1} season</option>
            <option value="last">${seasonStartYear-1}–${seasonStartYear} season</option>
          </select>
        </div>
        <div class="field" style="margin-bottom:0">
          <label>Status</label>
          <select id="aphStatusSel" data-action="set-status">
            <option value="">All</option>
            <option value="paid">Paid</option>
            <option value="due">Due</option>
            <option value="refunded">Refunded</option>
          </select>
        </div>
      </div>
      <div id="aphTableWrap"></div>
    </div>`;
  setTimeout(renderAdminHistoryTable, 0);
  return html;
};

VIEW_INIT['a-parent-history'] = () => {
  document.querySelectorAll('[data-action="export-history"]').forEach(btn => {
    btn.addEventListener('click', exportParentHistory);
  });
  const seasonSel = document.getElementById('aphSeasonSel');
  if (seasonSel) seasonSel.addEventListener('change', () => aphSetSeason(seasonSel.value));
  const statusSel = document.getElementById('aphStatusSel');
  if (statusSel) statusSel.addEventListener('change', () => aphSetStatus(statusSel.value));
};
